import { render } from "./RadioButtonsPage.vue?vue&type=template&id=618e8e60"
import script from "./RadioButtonsPage.vue?vue&type=script&lang=js"
export * from "./RadioButtonsPage.vue?vue&type=script&lang=js"

import "./RadioButtonsPage.vue?vue&type=style&index=0&id=618e8e60&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__